import { render, staticRenderFns } from "./true-money-webhook-modal.vue?vue&type=template&id=6c730486&scoped=true&"
import script from "./true-money-webhook-modal.vue?vue&type=script&lang=js&"
export * from "./true-money-webhook-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c730486",
  null
  
)

export default component.exports